import { jsx as t } from "react/jsx-runtime";
import { useMultiStyleConfig as a, Card as d, CardHeader as o, CardBody as s, CardFooter as n } from "@chakra-ui/react";
function u(r) {
  const e = a("CardTheme", r);
  return /* @__PURE__ */ t(d, { ...r, __css: e.container });
}
function i(r) {
  const e = a("CardTheme", r);
  return /* @__PURE__ */ t(o, { ...r, __css: e.header });
}
function y(r) {
  const e = a("CardTheme", r);
  return /* @__PURE__ */ t(s, { ...r, __css: e.body });
}
function f(r) {
  const e = a("CardTheme", r);
  return /* @__PURE__ */ t(n, { ...r, __css: e.footer });
}
export {
  u as Card,
  y as CardBody,
  f as CardFooter,
  i as CardHeader
};
//# sourceMappingURL=index.es.js.map
